import React, {Component} from 'react';
import PropTypes from 'prop-types';

import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SearchInput from "core/gd-ui/search/search";
import GDLoadingBlock from "src/core/gd-components/loading/gd-loading-overlap/block/gd-loading-block";
import DatetimeUtils from "core/gd/utils/datetime-utils";

import Classes from 'classnames';
import _ from 'lodash'
import ApiIntegrationGithub from "../../../../gd/api/integrations/github";
import ApiIntegrationGitlab from "../../../../gd/api/integrations/gitlab";

export default class GitSelectCommit extends Component {

    static propTypes = {
        branch: PropTypes.object,
        gitProvider: PropTypes.string,
        repositoryId: PropTypes.string,
        companyId: PropTypes.string,

        onSelectCommit: PropTypes.func,
        onClick: PropTypes.func
    }

    state = {
        searchString: '',
        isLoading: true
    }

    constructor(props) {
        super(props);

        let request;
        switch (this.props.gitProvider) {
            case 'github':
                request = ApiIntegrationGithub.getCommits(this.props.branch.id)
                break;

            case 'gitlab':
                request = ApiIntegrationGitlab.getCommits(this.props.repositoryId, this.props.branch.name)
                break;
        }

        request.done(response=>{
            this.setState({
                isLoading: false,
                commits: response
            })
        });
    }

    onSearchChange = (searchString) => {
        this.setState({
            searchString: searchString
        });
    };

    renderList = () => {
        if (this.state.isLoading) return false;

        let commits = this.state.commits.slice();

        if (this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase();
            commits = _.filter(commits, b=>b.title.toLowerCase().includes(searchString))
        }

        return (
            commits.map((commit) => (
                <div key={commit.id} className="list-item repository" onClick={() => this.props.onSelectCommit(commit)}>
                    <div className={Classes('icon', 'i5-git-commit')}/>
                    <div className="commit">
                        <div className="left">{commit.title}</div>
                        <div className="right">
                            <div className="name">{commit.committerName}</div>
                            <div className="separator">/</div>
                            <div className="date">{DatetimeUtils.datetimeToMoment(commit.moment).format(DatetimeUtils.shortDateFormat)}</div>
                        </div>
                    </div>
                </div>
            ))
        )
    };

    render() {
        return (
            <div className="main" >
                {this.state.isLoading && <GDLoadingBlock /> }
                <div className="search">
                    <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                </div>

                <VScroll containerClass="main-container">
                    <div className="list">{this.renderList()}</div>
                </VScroll>
            </div>
        );
    }
}
